// import { Component, OnInit } from '@angular/core';

// @Component({
//   selector: 'app-errorcodenew',
//   templateUrl: './errorcodenew.component.html',
//   styleUrls: ['./errorcodenew.component.scss']
// })
// export class ErrorcodenewComponent implements OnInit {

//   constructor() { }

//   ngOnInit() {
//   }

// }

import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { GUID } from "src/app/guid";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastService } from "ng-uikit-pro-standard";
import { DataService } from "src/app/data.service";

@Component({
  selector: "app-errorcodenew",
  templateUrl: "./errorcodenew.component.html",
  styleUrls: ["./errorcodenew.component.scss"]
})
export class ErrorcodenewComponent implements OnInit {
  actionForm!: FormGroup;
  guid: GUID;
  isLoading = false;
  isError = false;
  errorMessage = "";
  errorCategories: any[] = [];
  errorCodeId: string;
  errcode: any; // Picklist Options
  severityOptions = [
    { value: "INFO", label: "INFO" },
    { value: "WARN", label: "WARN" },
    { value: "ERROR", label: "ERROR" },
    { value: "CRITICAL", label: "CRITICAL" }
  ];

  logLevelOptions = [
    { value: "DEBUG", label: "DEBUG" },
    { value: "INFO", label: "INFO" },
    { value: "WARN", label: "WARN" },
    { value: "ERROR", label: "ERROR" }
  ];

  exposureOptions = [
    { value: "USER", label: "User" },
    { value: "ADMIN", label: "ADMIN" },
    { value: "INTERNAL", label: "INTERNAL" }
  ];

  mode = "new";

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private toastrService: ToastService,
    private dataService: DataService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.guid = new GUID();
    this.getErrorCategory(); // ✅ CALL HERE
    this.errorCodeId = this.route.snapshot.params.id;
    this.mode = this.route.snapshot.params.mode;
    if (this.mode.toLocaleLowerCase() == "edit") {
      // this.actionForm.controls.type.disable();
      this.getErrorcodeId();
    }
    this.buildForm();
  }

  buildForm() {
    this.actionForm = this.fb.group({
      code: ["", [Validators.required]],
      errorcategory: ["", Validators.required],
      httpstatus: [""],
      severity: [""],
      loglevel: [""],
      exposure: [""],
      retryable: [false],
      transient: [false],
      docurl: [""],
      remediationhints: [""],
      version: [""]
    });
  }

  showSuccess(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-top-right",
      timeOut: 3000
    };
    this.toastrService.success(data, "", options);
  }

  showError(data: any) {
    let options = { enableHtml: true, positionClass: "md-toast-bottom-right" };
    this.toastrService.error(data, "Metaobject Error!", options);
  }

  showWarning(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-bottom-right",
      messageClass: "orange darken-4",
      toastClass: "warning-color-dark"
    };
    this.toastrService.warning(data, "", options);
  }

  // save() {
  //   if (this.actionForm.invalid) {
  //     this.actionForm.markAllAsTouched();
  //     return;
  //   }

  //   console.log("Form Data:", this.actionForm.value);
  // }

  getErrorCategory() {
    const organizationid = localStorage.getItem("crm_orgid");
    const domain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.domain`
    );
    const subdomain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.subdomain`
    );

    this.isLoading = true;

    this.dataService.getErrorMessageCategory(domain, subdomain).subscribe(
      (res) => {
        if (res && res.success == 1) {
          const categoryData = res.data.errorcategory;
          let categoryArr = [];

          for (let i = 0; i < categoryData.length; i++) {
            let label = categoryData[i].categoryname;
            label = label.charAt(0).toUpperCase() + label.slice(1);

            categoryArr.push({
              value: categoryData[i].id,
              label: label
            });
          }

          this.errorCategories = categoryArr;
        }

        this.isLoading = false;
      },
      (err) => {
        this.showError(err.message);
        this.isLoading = false;
      }
    );
  }

  getErrorcodeId() {
    return new Promise((resolve, reject) => {
      console.log("getcrudmessages");

      // alert(id)
      const id = this.errorCodeId;
      // const domain = localStorage.getItem("domain");
      // const subdomain = localStorage.getItem("subdomain");
      const domain = localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      );
      const subdomain = localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      );
      this.isLoading = true;
      this.dataService.getErrorcodeById(domain, subdomain, id).subscribe(
        (res) => {
          console.log("res", res);

          if (res.success == 1) {
            // this.errcode = res.data.errorcode[0];
            this.errcode = res.data.errorcode[0];
            console.log("Doneeee****", this.errcode);

            if (this.errcode) {
              this.actionForm.patchValue({
                code: this.errcode.errorcode,
                errorcategory: this.errcode.categoryid,
                httpstatus: this.errcode.httpstatus,
                severity: this.errcode.severity,
                loglevel: this.errcode.loglevel,
                exposure: this.errcode.exposure,
                retryable: this.errcode.retryable === "true",
                transient: this.errcode.transient === "true",
                docurl: this.errcode.docurl,
                remediationhints: this.errcode.remediationhints,
                version: this.errcode.version
              });
            }

            // if (this.errcode != null) {
            //   this.actionForm.controls["code"].setValue(this.errcode.code);
            //   this.actionForm.controls["errorcategory"].setValue(
            //     this.errcode.languagecode
            //   );
            //   this.actionForm.controls["httpstatus"].setValue(
            //     this.errcode.errorcode
            //   );
            //   this.errorCodeId = this.errcode.errorcodeid;

            //   this.actionForm.controls["severity"].setValue(
            //     this.errcode.categoryid
            //   );
            //   if (this.errcode.organizationid != null) {
            //     this.actionForm.controls["type"].setValue("tenant");
            //   } else {
            //     this.actionForm.controls["loglevel"].setValue("common");
            //   }
            // }

            this.isLoading = false;
          } else {
            console.log("Error while saving");
            this.isLoading = false;
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

  save() {
    // ✅ Required Field Validation
    if (
      !this.actionForm.controls["code"].value ||
      this.actionForm.controls["code"].value.toString().trim() === ""
    ) {
      this.showWarning("Error Code is mandatory");
      return;
    }
    if (
      this.actionForm.controls["errorcategory"].value.toString().trim() === ""
    ) {
      this.showWarning("Error Category is mandatory");
      return;
    }

    // const httpStatus = this.actionForm.controls["httpstatus"].value;
    // if (httpStatus) {
    //   if (httpStatus < 100 || httpStatus > 599) {
    //     this.showWarning("HTTP Status must be between 100 and 599");
    //     return;
    //   }
    // }

    // ✅ JSON Validation for Remediation Hints
    // let remediationHintsArray: any = [];
    // try {
    //   const hints = this.actionForm.controls["remediationhints"].value;

    //   if (hints && hints.toString().trim() !== "") {
    //     remediationHintsArray = JSON.parse(hints);

    //     if (!Array.isArray(remediationHintsArray)) {
    //       this.showWarning("Remediation Hints must be a JSON array");
    //       return;
    //     }
    //   }
    // } catch (error) {
    //   this.showWarning("Remediation Hints must be valid JSON format");
    //   return;
    // }

    // ✅ Generate GUID
    if (this.mode === "new") {
      this.errorCodeId = this.guid.getGUID("errorcode");
    }

    // ✅ Prepare Post Object
    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),
      data: {
        errorcode: {
          id: this.errorCodeId,
          mode: this.mode, // change if you implement edit mode
          code: this.actionForm.controls["code"].value.trim(),
          errorcategoryid:
            this.actionForm.controls["errorcategory"].value.trim(), // ✅ ADD THIS
          httpstatus: this.actionForm.controls["httpstatus"].value,
          severity: this.actionForm.controls["severity"].value,
          loglevel: this.actionForm.controls["loglevel"].value,
          exposure: this.actionForm.controls["exposure"].value,
          retryable: this.actionForm.controls["retryable"].value,
          transient: this.actionForm.controls["transient"].value,
          docurl: this.actionForm.controls["docurl"].value,
          remediationhints: this.actionForm.controls["remediationhints"].value,
          version: this.actionForm.controls["version"].value
        }
      }
    };

    console.log("Post Object:", postOption);

    // ✅ Start Loading
    this.isLoading = true;

    // 🔥 CALL YOUR API HERE

    this.dataService.upsertErrorCode(postOption).subscribe(
      (res) => {
        //alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          this.showSuccess(res.message);
          this.isLoading = false;
          this.router.navigateByUrl("home/errorcodelist");
        } else {
          console.log("error while saving");
          this.showError(res.message);
          this.isLoading = false;
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.showError(err.message);
        this.isError = true;
        this.isLoading = false;
      }
    );

    // Temporary success (remove after API integration)
    this.showSuccess("Error Code saved successfully");
    this.isLoading = false;
  }

  cancel() {
    this.router.navigateByUrl("home/errorcodelist");
  }
}
